"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTest = exports.isExperimentalErrorTracker = exports.isDevelopment = exports.enableErrorTracker = void 0;
var isDevelopment = exports.isDevelopment = function isDevelopment() {
  return process.env.NODE_ENV === 'development';
};
var isTest = exports.isTest = function isTest() {
  return process.env.NODE_ENV === 'test';
};
var isExperimentalErrorTracker = exports.isExperimentalErrorTracker = function isExperimentalErrorTracker() {
  return process.env.COZY_EXPERIMENTAL_ERROR_TRACKER === 'true';
};
var enableErrorTracker = exports.enableErrorTracker = function enableErrorTracker() {
  return isDevelopment() && isExperimentalErrorTracker() || isTest();
};